import React from "react";
import { Button } from "primereact/button";
import { Dropdown, DropdownChangeEvent } from "primereact/dropdown";
import { InputNumber, InputNumberChangeEvent } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { useGetEventTypesQuery } from "../../store/services/events-types";
import { limitsTypes } from "../../utils/constants/forms-constants";

interface InstitutionalCommunicationFiltersProps {
  communicationId?: number;
  setCommunicationId?: React.Dispatch<React.SetStateAction<number | undefined>>;
  communicationName?: string;
  setCommunicationName?: React.Dispatch<React.SetStateAction<string>>;
  communicationType?: string;
  setCommunicationType?: React.Dispatch<React.SetStateAction<string | undefined>>;
  recordsLimit?: number;
  setRecordsLimit?: React.Dispatch<React.SetStateAction<number>>;
}

export const InstitutionalCommunicationFilters = ({
  communicationId,
  setCommunicationId = () => {},
  communicationName,
  setCommunicationName = () => {},
  communicationType,
  setCommunicationType = () => {},
  recordsLimit,
  setRecordsLimit = () => {},
}: InstitutionalCommunicationFiltersProps) => {
  const { data: communicationTypes, isLoading: isLoadingCommunicationTypes } =
    useGetEventTypesQuery();

  const handleDropdownChange =
    (filterName: "type" | "limit") =>
    ({ value }: DropdownChangeEvent) => {
      if (filterName === "type") setCommunicationType(value);
      if (filterName === "limit") setRecordsLimit(value);
    };

  const handleNameChange = ({ currentTarget }: React.ChangeEvent<HTMLInputElement>) => {
    setCommunicationName(currentTarget.value);
  };

  const handleCommunicationIdChange = ({ value }: InputNumberChangeEvent) => {
    setCommunicationId(value || undefined);
  };

  const clearFilter = (filterName: "name" | "id" | "type" | "limit") => () => {
    if (filterName === "name") setCommunicationName("");
    if (filterName === "id") setCommunicationId(undefined);
    if (filterName === "type") setCommunicationType(undefined);
    if (filterName === "limit") setRecordsLimit(10);
  };

  return (
    <div className="grid">
      <div className="col-12">
        <h3 className="m-0">Filtros</h3>
      </div>
      <div className="col-12 sm:col-8 p-inputgroup my-3">
        <span className="p-float-label lg:w-6">
          <InputText
            id="communicationName"
            name="communicationName"
            onChange={handleNameChange}
            value={communicationName}
          />
          <label htmlFor="communicationName">Nombre</label>
        </span>
        <Button
          icon="pi pi-times"
          className="p-button-danger"
          onClick={clearFilter("name")}
        />
      </div>

      <div className="col-12 sm:col-4 p-inputgroup my-3">
        <span className="p-float-label w-full">
          <Dropdown
            id="recordsLimit"
            name="recordsLimit"
            onChange={handleDropdownChange("limit")}
            value={recordsLimit}
            optionLabel="name"
            optionValue="value"
            options={limitsTypes}
          />
          <label htmlFor="recordsLimit">Límite</label>
        </span>
        <Button
          icon="pi pi-times"
          className="p-button-danger"
          onClick={clearFilter("limit")}
        />
      </div>

      <div className="col-12 sm:col-6 lg:col-3 p-inputgroup">
        <span className="p-float-label">
          <Dropdown
            id="communicationType"
            name="communicationType"
            onChange={handleDropdownChange("type")}
            value={communicationType}
            optionLabel="eventTypeName"
            optionValue="eventTypeName"
            options={Array.isArray(communicationTypes) ? communicationTypes : []}
            loading={isLoadingCommunicationTypes}
          />
          <label htmlFor="communicationType">Tipo (categoría)</label>
        </span>
        <Button
          icon="pi pi-times"
          className="p-button-danger"
          onClick={clearFilter("type")}
        />
      </div>

      <div className="col-12 sm:col-6 lg:col-3 p-inputgroup">
        <span className="p-float-label">
          <InputNumber
            id="communicationId"
            name="communicationId"
            onChange={handleCommunicationIdChange}
            value={communicationId}
          />
          <label htmlFor="communicationId">ID #</label>
        </span>
        <Button
          icon="pi pi-times"
          className="p-button-danger"
          onClick={clearFilter("id")}
        />
      </div>
    </div>
  );
};
